/**
 *
 * Header
 *
 */

import React, { Fragment } from "react"
import { Menu, Dropdown, Divider, Tooltip } from "antd"
import { NavLink } from "react-router-dom"
import img from "images/brand/Mandu_white.svg"
import UserHeaderBox from "containers/UserHeaderBox"
import NotificationContainer from "containers/NotificationContainer"
import { QuestionCircleFilled } from "@ant-design/icons"
import chat from "images/chat.svg"
import helpCenterIcon from "images/help-center-icon.svg"
import {
  hasAdminRole,
  isAdmin,
  isAmbassador,
  isLeader,
  isModuleBySlug,
} from "../../../utils/storage"
import { DASHBOARD, REPORTS } from "../../../utils/constants"
import { loadTexts, sanitize } from "../../../utils/i18n"
import { buttonAction_btns } from "../../Snowplow/config2"

class Leader extends React.Component {
  intl = loadTexts("header")
  dropdownQuestions = (
    <Menu style={{ padding: 0, width: 184, color: "#a1a1a1" }}>
      <Menu.Item className="damnMenuItem dropdown-option">
        <a href="https://intercom.help/center-mandu" target="_blank" rel="noreferrer" onClick={() => buttonAction_btns("Ir a Help Center")}>
          {this.intl?.questionMarkOptions?.helpCenter}
        </a>
      </Menu.Item>
      <Menu.Item
        className="damnMenuItem dropdown-option"
        id="dsadasdas"
        onClick={() => window.open("https://intercom-help.eu/mandu/es/collections/1400663-mandu-experience", "_blank")}>
        <Tooltip title="Help center" placement="bottom">
          <img src={helpCenterIcon} alt="Help Center" style={{ width: "21px", height: "21px", marginRight: 0 }} />
        </Tooltip>
      </Menu.Item>
    </Menu>
  )

  render() {
    const isReportModule = isModuleBySlug(REPORTS)
    const isDashboardModule = isModuleBySlug(DASHBOARD)

    if(window.top !== window.self) {
      return null
    }
    
    return (
      <div className="container-header">
        <div className="container-header__left">
          <Fragment>
            <img width={80} src={img} className="container-header__logo" />
            <Divider type="vertical" />
            {isDashboardModule && (
              <NavLink
                exact
                className="container-header__left-item step-menu-dashboard"
                activeClassName="container-header-active"
                to="/">
                {this.intl?.menuOptions?.dashboard}
              </NavLink>
            )}
            <Divider type="vertical" />
            {isReportModule && (
              <NavLink
                className="container-header__left-item step-menu-reports"
                activeClassName="container-header-active"
                to="/reports/dashboard">
                {this.intl?.menuOptions?.reports}
              </NavLink>
            )}
            <Divider type="vertical" />
          </Fragment>
        </div>
        <div className="container-header__right">

          <Fragment>
            {/*
            <Dropdown
              overlay={this.dropdownQuestions}
              placement="bottomRight"
              className="container-header__left-item step-menu-help-center">
              <QuestionCircleFilled
                type="question-circle"
                theme="filled"
                style={{
                  color: "white",
                  fontSize: "16px",
                  padding: "12px 10px",
                }}
              />
            </Dropdown>
             */}
            <Tooltip title="Help center" placement="bottom">
              <span className="container-header__left-item" style={{ fontWeight: "600", color: "white", cursor: "pointer" }}
                onClick={() => { window.open("https://intercom-help.eu/mandu/es/collections/1400663-mandu-experience", "_blank"); buttonAction_btns("Ir a Help Center") }}>
                <img src={helpCenterIcon} alt="Help Center" style={{ width: "21px", height: "21px", marginRight: 0 }} />
              </span>
            </Tooltip>
            <Divider type="vertical" />
            <NotificationContainer />
            <Divider type="vertical" />
          </Fragment>

          <UserHeaderBox
            changeRole={hasAdminRole() && isLeader() ? "Administrador" : null}
          />
        </div>
      </div>
    )
  }
}

Leader.propTypes = {}

export default Leader
